import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { AnalyticsSpinner } from '../../../components/common/Spinner/AnalyticsSpinner';
import PageLayout from '../../../components/common/PageLayout/PageLayout';
import { validateAndGetGrantPageUrl, redirectToShopify } from '../../../store/actions/shopifyAppInstall';

export function ShopifyAuthContainer({ shopifyAppType }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const { redirectUrl } = useSelector((state) => state.shopify);

  useEffect(() => {
    if (redirectUrl) {
      return redirectToShopify({
        url: redirectUrl,
      });
    }

    const queryParams = new URLSearchParams(location.search);
    queryParams.append('app_type', shopifyAppType);

    dispatch(validateAndGetGrantPageUrl(queryParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectUrl]);

  return (
    <PageLayout>
      <AnalyticsSpinner fullScreen />
    </PageLayout>
  );
}
